// extracted by mini-css-extract-plugin
export default {"tooltip":"XX3riyYHy3ZOLPOHi7HR","tooltip__icon":"vchyzRZFM__8UmqQA4ic","tooltip__text":"cpaLoD345x37g9J91mp8"};